import { render, staticRenderFns } from "./avalonTextSettings.vue?vue&type=template&id=b44d5f34&scoped=true&"
import script from "./avalonTextSettings.vue?vue&type=script&lang=js&"
export * from "./avalonTextSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44d5f34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VExpandTransition})
